'use strict';

var React = require('react');

var SvgSendMajor = function SvgSendMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m4.798 9.657-1.964-5.374c-.306-.84.557-1.629 1.365-1.248l12.878 6.06a1 1 0 0 1 0 1.81l-12.878 6.06c-.808.38-1.671-.41-1.365-1.248l1.964-5.374a1 1 0 0 0 0-.686Zm1.409-.515-1.547-4.233 9.224 4.341h-7.64a2.507 2.507 0 0 0-.037-.108Zm.036 1.608a2.5 2.5 0 0 1-.036.108l-1.547 4.232 9.223-4.34h-7.64Z"
  }));
};
SvgSendMajor.displayName = "SendMajor";

exports.SvgSendMajor = SvgSendMajor;
